/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Toast_Deactivated2Inputs */

const en_settings_reportingapikeys_toast_deactivated2 = /** @type {(inputs: Settings_Reportingapikeys_Toast_Deactivated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key deactivated`)
};

/**
* | output |
* | --- |
* | "API key deactivated" |
*
* @param {Settings_Reportingapikeys_Toast_Deactivated2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_toast_deactivated2 = /** @type {((inputs?: Settings_Reportingapikeys_Toast_Deactivated2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Toast_Deactivated2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_toast_deactivated2(inputs)
});
export { settings_reportingapikeys_toast_deactivated2 as "settings_reportingApiKeys_toast_deactivated" }